import { Slot } from '@radix-ui/react-slot';
import type { Variants } from 'motion/react';
import * as React from 'react';
import type { MotionVariantsType } from './variants';

type MotionProps<C extends React.ElementType = 'div'> = Omit<
	React.ComponentPropsWithoutRef<C>,
	'as'
> & {
	as?: C;
	asChild?: boolean;
	variants?: Variants;
	initial?: MotionVariantsType | MotionVariantsType[];
	animate?: MotionVariantsType | MotionVariantsType[];
	exit?: MotionVariantsType | MotionVariantsType[];
};

export const Component = React.forwardRef<any, MotionProps>(
	({ variants, as = 'div', asChild, ...props }, ref) => {
		const Comp = asChild ? Slot : as;
		return React.createElement(Comp, { ref, ...props });
	},
);

Component.displayName = 'Motion';
